/**
 * AI Assistant — declarative page adapter (G2).
 *
 * Pages whose component itself renders `<EmployerLayout>` cannot call
 * `useAssistantPage()` in their own body (the provider lives inside the
 * layout). They drop this element inside the layout instead:
 *
 *   <EmployerLayout>
 *     <AssistantPage page="hiring-lifecycle" candidates={candidates} />
 *     …
 *   </EmployerLayout>
 *
 * Renders nothing; the props are the page spec (see useAssistantPage.js).
 */
import { useAssistantPage } from './useAssistantPage';

export function AssistantPage(spec) {
  useAssistantPage(spec);
  return null;
}

export default AssistantPage;
